<script lang="ts">
	import type { FinancialNumber } from 'shared/number'

	import { format_money_$_with_optional_cents } from 'shared/format_currency'
	import { calculate_holster_or_accessory_final_price } from 'shared/bzns/holster/holster_pricing'

	import BigNumber from './BigNumber.svelte'

	export let base_price: FinancialNumber
	export let promo_discount_rate: FinancialNumber
	export let promo_active: boolean
	export let product_title: string
	export let price_can_increase = true

	$: final_price = calculate_holster_or_accessory_final_price({
		base_price,
		promo_discount_rate,
		promo_active,
	})
</script>

<div style="display: flex; justify-content: space-between; align-items: center; gap: 8px; flex-wrap: wrap;">
	<h1 class="product_title">{product_title}</h1>
	<div class="price">
		{#if promo_active && Number(promo_discount_rate) > 0}
			<BigNumber style="--color: var(--disabled-gray)">
				<del>
					{format_money_$_with_optional_cents(base_price)}{#if price_can_increase}+{/if}
				</del>
			</BigNumber>
		{/if}
		<BigNumber>
			{format_money_$_with_optional_cents(final_price)}{#if price_can_increase}+{/if}
		</BigNumber>
	</div>
</div>

<style>
	.product_title {
		font-size: 32px;
		text-transform: none;
	}
	.price {
		display: flex;
		justify-content: end;
		align-items: center;
		gap: 8px;
		flex-grow: 1;
		text-align: right;
	}
</style>
